import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import DataOffers from "@/data/AdminPanel/DataOffers";
import ApiOffer from "@/api/ApiOffer";
import sweetalert from "sweetalert";
import { Getter } from "vuex-class";
import EUserEnum from "@/struct/user/EUserEnum";
import ApiRegion from "@/api/ApiRegion";
let Offers = class Offers extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = DataOffers.Breadcrumbs;
        this.TableHeaders = DataOffers.TableHeaders;
        this.TableItems = [];
        this.OffersCategories = [];
        this.HasRequest = false;
        this.regionItems = [];
        this.defaultRegion = null;
        this.selectRegion = null;
        this.selectedFacility = process.env.VUE_APP_FACILITY_ID;
    }
    CanAddAndEditAccess() {
        return (this.GetCurrentSessionUser != undefined &&
            (this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Admin ||
                this.GetCurrentSessionUser.system_role ==
                    EUserEnum.SystemRole.SuperAdmin ||
                this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Editor));
    }
    CanDeleteAccess() {
        return (this.GetCurrentSessionUser != undefined &&
            (this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Admin ||
                this.GetCurrentSessionUser.system_role ==
                    EUserEnum.SystemRole.SuperAdmin));
    }
    async getOffersCategories() {
        try {
            this.OffersCategories = await ApiOffer.GetOfferCategories(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            console.error(e);
        }
    }
    async getOffers(facility) {
        this.HasRequest = true;
        try {
            this.TableItems = await ApiOffer.GetOffers(ApiEnter.CurrentSessionUUID, facility);
        }
        catch (e) {
            console.error(e);
        }
        this.HasRequest = false;
    }
    async getCMSRegions() {
        this.HasRequest = true;
        try {
            const regions = await ApiRegion.GetRegions();
            this.regionItems = regions.map((item) => ({
                name: item.display_name,
                facility_id: item.facility_id,
                default: item.default,
            }));
            this.defaultRegion =
                this.regionItems.find((item) => item.default === 1) || null;
            if (this.defaultRegion) {
                this.selectRegion = this.defaultRegion.facility_id;
            }
        }
        catch (e) {
            console.error(e);
        }
        this.HasRequest = false;
    }
    //private getDefaultRegion() {}
    filterRegion() {
        if (this.selectRegion) {
            const selectedRegion = this.regionItems.find((item) => item.facility_id === this.selectRegion);
            if (selectedRegion) {
                this.selectedFacility = selectedRegion.facility_id.toString();
                this.getOffers(this.selectedFacility);
            }
        }
        else {
            this.selectedFacility = process.env.VUE_APP_FACILITY_ID;
            this.getOffers(this.selectedFacility);
        }
    }
    async ChangePublish(item) {
        try {
            const response = await ApiOffer.UpdateOfferPublish(item.publish ? 1 : 0, ApiEnter.CurrentSessionUUID, item.uuid);
            if (typeof response == "boolean") {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success",
                }).then(() => {
                    this.getOffers(this.selectedFacility);
                });
            }
            else {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        catch (e) {
            console.error(e);
            await sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
    }
    async DeleteItem(offer_uuid) {
        sweetalert({
            title: this.$t("general.confirm"),
            text: this.$t("offers.confirm_delete"),
            buttons: [
                this.$t("general.no"),
                this.$t("general.yes"),
            ],
        }).then(async (isConfirm) => {
            if (isConfirm == true) {
                const response = await ApiOffer.DeleteOffer(ApiEnter.CurrentSessionUUID, offer_uuid);
                if (typeof response == "boolean") {
                    await sweetalert({
                        title: this.$t("general.success"),
                        text: this.$t("general.success_deleted"),
                        icon: "success",
                    });
                    await this.getOffers(this.selectedFacility);
                }
                else {
                    await sweetalert({
                        title: this.$t("general.error"),
                        text: this.$t("general.request_error"),
                        icon: "info",
                    });
                }
            }
        });
    }
    mounted() {
        this.getOffersCategories();
        this.getCMSRegions();
        this.filterRegion();
    }
    created() {
        this.getOffers(this.selectedFacility);
        this.getCMSRegions();
        this.filterRegion();
    }
};
__decorate([
    Getter("getCurrentSessionUser")
], Offers.prototype, "GetCurrentSessionUser", void 0);
Offers = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], Offers);
export default Offers;
